var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-03",
    clipPath: "url(#clip0_2197_13094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.00004 1.33334C10 2.66668 10.6152 5.52803 10.6667 8.00001C10.6152 10.472 10 13.3333 8.00004 14.6667M8.00004 1.33334C6.00004 2.66668 5.38487 5.52803 5.33337 8.00001C5.38487 10.472 6.00004 13.3333 8.00004 14.6667M8.00004 1.33334C4.31814 1.33334 1.33337 4.31811 1.33337 8.00001M8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001M8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001M14.6667 8.00001C13.3334 10 10.472 10.6152 8.00004 10.6667C5.52806 10.6152 2.66671 10 1.33337 8.00001M14.6667 8.00001C13.3334 6.00001 10.472 5.38484 8.00004 5.33334C5.52806 5.38484 2.66671 6.00001 1.33337 8.00001",
    stroke: "#5A6081",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2197_13094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobe);
export default __webpack_public_path__ + "static/media/ic-globe.e41d1e3477c8baac607b8f5271983a2c.svg";
export { ForwardRef as ReactComponent };